module.exports = __webpack_public_path__ + "img/foot.19d4d060.png";